import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { type DistributionAssetInput, distributionAssetQueryKey, fetchDistributionAsset } from '../distributionAsset';

/** The vault asset every deposit is formatted in; null when it can't be formatted. */
export const useDistributionAsset = input => {
  const $ = _c(7);
  let t0;
  if ($[0] !== input) {
    t0 = distributionAssetQueryKey(input);
    $[0] = input;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== input) {
    t1 = () => fetchDistributionAsset(input);
    $[2] = input;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      staleTime: Infinity
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
};